"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.validateLink = exports.compositeValidator = exports.getFileTypeMessage = exports.checkFileType = void 0;

var _ramda = require("ramda");

var yup = _interopRequireWildcard(require("yup"));

var _moment = _interopRequireDefault(require("moment"));

var _classValidator = require("class-validator");

var _libphonenumberJs = require("libphonenumber-js");

var _i18n = _interopRequireDefault(require("./i18n"));

var _regexps = require("../constants/regexps");

var _allowFileExtensions = require("../constants/allowFileExtensions");

var checkDate = function checkDate(value) {
  return !value || value === 'incomplete';
};

var checkFileType = function checkFileType(fileType, mimeType, extenstion) {
  var allowFileExtensions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  switch (fileType) {
    case 'audio':
      return (0, _ramda.startsWith)('audio', mimeType);

    case 'video':
      return (0, _ramda.startsWith)('video', mimeType);

    case 'image':
      var allowFileTypes = (0, _ramda.join)(',', (0, _ramda.values)(allowFileExtensions && !(0, _ramda.isEmpty)(allowFileExtensions[fileType]) ? allowFileExtensions[fileType] : _allowFileExtensions.defaultAllowFileExtensions[fileType]));
      return allowFileTypes ? (0, _ramda.contains)(mimeType, (0, _ramda.split)(',', (0, _ramda.replace)(/\s/g, '', allowFileTypes))) : true;

    default:
      return !fileType || (allowFileTypes ? allowFileExtensions[fileType][extenstion] : _allowFileExtensions.defaultAllowFileExtensions[fileType][extenstion]);
  }
};

exports.checkFileType = checkFileType;

var getFileTypeMessage = function getFileTypeMessage(type) {
  var allowFileExtensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (type) {
    case 'audio':
      return _i18n["default"].t('errors.fileTypeAudio');

    case 'video':
      return _i18n["default"].t('errors.fileTypeVideo');

    default:
      if (allowFileExtensions && !(0, _ramda.isEmpty)(allowFileExtensions[type])) {
        return _i18n["default"].t('errors.fileType', {
          types: (0, _ramda.join)(', ', (0, _ramda.keys)(allowFileExtensions[type]))
        });
      } else {
        return _i18n["default"].t('errors.fileType', {
          types: (0, _ramda.prop)(type, _allowFileExtensions.VALIDATION_FILE_TYPES)
        });
      }

  }
};

exports.getFileTypeMessage = getFileTypeMessage;

var compositeValidator = function compositeValidator(value) {
  return value && value.length > 0 ? undefined : _i18n["default"].t('errors.composite');
};

exports.compositeValidator = compositeValidator;

var validateLink = function validateLink(field, values) {
  var linkField = (0, _ramda.path)(['settings', 'linkField'], field);
  var linkValue = (0, _ramda.path)(['settings', 'linkValue'], field);

  if (!linkField) {
    return false;
  } else {
    var linkedValue = (0, _ramda.path)((0, _ramda.split)('.', "".concat(linkField)), values);
    return linkValue === linkedValue;
  }
};

exports.validateLink = validateLink;
var rules = {
  text: function text(field) {
    return yup.string().nullable().test({
      name: 'text',
      message: _i18n["default"].t('errors.required'),
      test: function test(value) {
        var mask = (0, _ramda.path)(['settings', 'mask'], field);
        var minLength = (0, _ramda.path)(['settings', 'minLength'], field);

        if (!value || !mask || !(0, _ramda.is)(String, mask)) {
          return true;
        }

        var parsedValue = value.replace(/[\s]+/gm, '');
        var parsedMask = mask.replace(/[\s]+/gm, '');
        var maskFull = parsedMask.length === parsedValue.length;
        var maskMin = parsedValue.length >= minLength && parsedValue.length <= parsedMask.length;
        return minLength ? maskMin : maskFull;
      }
    }).test({
      name: 'maxLength',
      message: _i18n["default"].t('errors.maxLength', {
        count: (0, _ramda.path)(['settings', 'maxLength'], field)
      }),
      test: function test(value) {
        var maxLength = (0, _ramda.path)(['settings', 'maxLength'], field);

        if (!value || !maxLength) {
          return true;
        }

        return value.length <= maxLength;
      }
    }).test({
      name: 'minLength',
      message: _i18n["default"].t('errors.minLength', {
        count: (0, _ramda.path)(['settings', 'minLength'], field)
      }),
      test: function test(value) {
        var minLength = (0, _ramda.path)(['settings', 'minLength'], field);

        if (!value || !minLength) {
          return true;
        }

        return value.length >= minLength;
      }
    });
  },
  phone: function phone(field) {
    return yup.string().nullable().test({
      name: 'phone',
      message: function message(_ref) {
        var value = _ref.value;
        var required = field.required;

        if (required && !value) {
          return _i18n["default"].t('errors.required');
        } else {
          return _i18n["default"].t('errors.phone');
        }
      },
      test: function test(value) {
        if (!value) {
          return true;
        }

        try {
          if ((0, _ramda.path)(['settings', 'international'], field)) {
            var phoneNumber = (0, _libphonenumberJs.parsePhoneNumberWithError)(value);
            return phoneNumber.isValid();
          } else {
            return (0, _classValidator.isPhoneNumber)(value, 'RU') || (0, _classValidator.isPhoneNumber)(value, 'KZ');
          }
        } catch (error) {
          if (error instanceof _libphonenumberJs.ParseError) {
            return false;
          }
        }
      }
    });
  },
  email: function email(field) {
    return yup.string().nullable().email(_i18n["default"].t('errors.email')).matches(_regexps.EMAIL_RFC, _i18n["default"].t('errors.email')).matches(_regexps.EMAIL_RFC_LOCALPART, _i18n["default"].t('errors.email')).test({
      name: 'emailChars',
      message: function message(_ref2) {
        var value = _ref2.value;
        var invalidChars = !_regexps.EMAIL_EXPERIUM.test(value);
        var invalidDomain = !_regexps.EMAIL_DOMAIN.test(value);

        if (invalidChars || invalidDomain) {
          return invalidDomain ? _i18n["default"].t('errors.emailDomain') : _i18n["default"].t('errors.emailChars');
        }
      },
      test: function test(value) {
        if (!value) {
          return true;
        }

        return _regexps.EMAIL_EXPERIUM.test(value);
      }
    }).test({
      name: 'maxLength',
      message: _i18n["default"].t('errors.maxLength', {
        count: (0, _ramda.path)(['settings', 'maxLength'], field)
      }),
      test: function test(value) {
        var maxLength = (0, _ramda.path)(['settings', 'maxLength'], field);

        if (!value || !maxLength) {
          return true;
        }

        return value.length <= maxLength;
      }
    });
  },
  personalDataAgreement: function personalDataAgreement(field, _ref3) {
    var htmlOpd = _ref3.htmlOpd,
        opdSettings = _ref3.opdSettings;
    return htmlOpd || (0, _ramda.path)(['useConstructor'], opdSettings) ? yup.string() : yup["boolean"]();
  },
  "boolean": function boolean(field) {
    return !field.required ? yup["boolean"]() : yup.mixed().test({
      name: 'requiredBoolean',
      message: _i18n["default"].t('errors.required'),
      test: function test(value) {
        return !!value;
      }
    });
  },
  choice: function choice(field) {
    return (0, _ramda.path)(['settings', 'multiple'], field) ? yup.array() : yup.string();
  },
  file: function file(field, _ref4) {
    var allowFileExtensions = _ref4.allowFileExtensions;
    return yup.mixed().test({
      name: 'fileExtensions',
      message: function message(_ref5) {
        var value = _ref5.value;
        var type = Array.isArray(value) ? (0, _ramda.prop)('type', (0, _ramda.head)(value)) : (0, _ramda.prop)('type', value);
        return getFileTypeMessage(type, allowFileExtensions);
      },
      test: function test(value) {
        if (!value) {
          return true;
        }

        if ((0, _ramda.path)(['settings', 'multiple'], field)) {
          var result = true;
          value.forEach(function (value) {
            if (result) {
              result = checkFileType(value.type, value.contentType, value.extenstion, allowFileExtensions);
            }
          });
          return result;
        } else {
          return checkFileType(value.type, value.contentType, value.extenstion, allowFileExtensions);
        }
      }
    });
  },
  money: function money(field) {
    return yup.object().shape({
      amount: field.required ? yup.number().nullable().required(function () {
        return _i18n["default"].t('errors.required');
      }).moreThan(0, function (_ref6) {
        var more = _ref6.more;
        return _i18n["default"].t('errors.moreThan', {
          more: more
        });
      }) : yup.number().nullable().moreThan(0, function (_ref7) {
        var more = _ref7.more;
        return _i18n["default"].t('errors.moreThan', {
          more: more
        });
      }),
      currency: yup.string().nullable().when('amount', function (amount, schema) {
        return amount ? schema.required(function () {
          return _i18n["default"].t('errors.currency');
        }) : schema;
      })
    });
  },
  date: function date() {
    return yup.string().nullable().test({
      name: 'completeDate',
      message: _i18n["default"].t('errors.incompleteDate'),
      test: function test(value) {
        return value !== 'incomplete';
      }
    });
  }
};

var validateBirthDate = function validateBirthDate(format) {
  return function (rule, form) {
    return rule.test({
      name: 'incorrectBirthDate',
      message: _i18n["default"].t('errors.incorrectBirthDate'),
      test: function test(value) {
        if (checkDate(value) || checkDate(form.birthDate)) {
          return true;
        }

        var birthDate = (0, _moment["default"])(form.birthDate, 'DD.MM.YYYY');
        var date = (0, _moment["default"])(value, format);
        return date.isAfter(birthDate);
      }
    });
  };
};

var additionalRules = {
  yearEnd: validateBirthDate('YYYY'),
  courseYearEnd: validateBirthDate('YYYY'),
  experienceStart: validateBirthDate('DD.YYYY'),
  experienceEnd: validateBirthDate('DD.YYYY')
};

var validate = function validate(value, form, field, fieldsWithoutValidation, props) {
  var customValidation = (0, _ramda.path)(['customValidation', field.field], props) || (0, _ramda.path)([field.field], additionalRules);

  try {
    var rule = rules[field.type] ? rules[field.type](field, props) : yup.string();
    rule = field.type === 'personalDataAgreement' ? rule.nullable().required(function () {
      return _i18n["default"].t('errors.required');
    }) : (field.required || validateLink(field, form)) && !fieldsWithoutValidation[field.field] ? rule.nullable().required(function () {
      return _i18n["default"].t('errors.required');
    }) : rule.nullable();
    rule = customValidation ? customValidation(rule, form) : rule;
    rule.validateSync(value);
    return undefined;
  } catch (e) {
    return "".concat(e.message);
  }
};

exports.validate = validate;